import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BookOpen, Sparkles } from 'lucide-react';
import HamburgerMenu from './HamburgerMenu';
import StoryNavSml from './StoryNavSml';

/**
 * PageHeader - Standard header component with logo and StoryNav
 * Used on all pages except the Welcome/Landing page
 *
 * Props:
 * - lightText: boolean - Use white text for dark backgrounds (default: false)
 * - borderBottom: boolean - Show bottom border (default: false)
 */
const PageHeader = ({ lightText = false, borderBottom = false }) => {
  const navigate = useNavigate();

  const textColor = lightText ? 'text-white' : 'text-slate-900';
  const subTextColor = lightText ? 'text-indigo-300' : 'text-indigo-600';
  const iconColor = lightText ? 'text-indigo-400' : 'text-indigo-600';

  return (
    <header className={`bg-transparent ${borderBottom ? 'border-b border-slate-200' : ''}`}>
      <div className="container mx-auto px-4 py-4">
        {/* Desktop: inline layout, Mobile: stacked layout */}
        <div className="flex flex-col lg:flex-row lg:items-start">
          {/* Logo */}
          <div
            className="flex items-center space-x-2 cursor-pointer hover:opacity-80 transition-opacity flex-shrink-0"
            onClick={() => navigate('/')}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && navigate('/')}
          >
            <BookOpen className={`h-8 w-8 ${iconColor}`} />
            <div>
              <span className={`text-2xl font-bold ${textColor}`}>TweePorter.ca</span>
              <div className={`flex items-center space-x-1 text-xs ${subTextColor} font-medium`}>
                <Sparkles className="h-3 w-3" />
                <span>Optimized for SugarCube</span>
              </div>
            </div>
          </div>

          {/* Spacing - only on desktop */}
          <div className="hidden lg:block" style={{ width: '50px' }} />

          {/* Story Map Navigation - below on mobile, inline on desktop */}
          <div className="mt-4 lg:mt-0 lg:flex-1 overflow-x-auto">
            <StoryNavSml />
          </div>
        </div>
      </div>
      <HamburgerMenu />
    </header>
  );
};

export default PageHeader;
